import React from 'react';
import './styles/welcome.scss'
import { WelcomePage } from './Welcome'


function App(this: any) {
    
  return (
    <WelcomePage />
  );
}

export default App;
